import common from './common';
import Module from './module';
import Util from './lib/util';

class ContactModal extends Module {

    init() {
        return super.init().then(() => this.emit('init'));
    }

    main() {
        const form = $('#form784');

        form.validate({
            wrapper: 'span',
            errorClass: 'input-validation-error',
            errorElement: 'span',
            errorPlacement: (err, el) => {
                el.closest('.nha-form-group').addClass('nha-form-error');
                err.addClass('field-validation-error').addClass('nha-form-error-desc');
                err.insertAfter(el);
                err.removeAttr('style');
            }
        });
    }

    bindEvents() {
        $('#form784').on('click.validate focusin.validate focusout.validate keyup.validate', e => this.onFormChanged(e));
        $('#form784').on('focusout.validate', Util.debounce(e => this.onFormBlurred(e)));
        $('#form784').on('submit', function(e) {
            e.preventDefault();

            if ($('#form784').valid()) {
                $.post($('#form784').attr('action'), $('#form784').serialize());
                $('#form784 .nha-contact-me-body').hide();
                $('#nha-modal-confirmation').show();
            }
        });
    }

    onFormBlurred(e) {
        $(e.target).valid();    // validate the field that was blurred
        this.onFormChanged(e);
    }

    onFormChanged(e) {
        $('form#form784 .nha-form-control').each((i, el) => {
            let field = $(el);
            let group = field.closest('.nha-form-group');

            group.removeClass('nha-form-error');
            if (field.hasClass('input-validation-error') && !field.hasClass('valid')) group.addClass('nha-form-error');
            group.find('.nha-form-error-desc').removeAttr('style');
        })
    }
}


const contactModal = new ContactModal();

common.on('init', () => contactModal.init());

export default contactModal;



// WEBPACK FOOTER //
// ./wwwroot/js/app/contact-modal.js